module.exports = __webpack_public_path__ + "static/media/PC_top_ranking_recipe.1ef28d69.jpg";